import { Popover as UiPopover } from '@material-ui/core';
import cn from 'classnames';
import Button from 'components/form/Button';
import Icon from 'components/Icon';
import Select, { SelectProps } from '..';
import { DropdownButtonProps } from '../DropdownButton';
import selectStyles from '../index.module.css';
import { PopoverProps } from '../Popover';
import styles from './index.module.css';

function DropdownButtonWhite(props: DropdownButtonProps) {
	const { onClick, open, children, dataTest } = props;

	return (
		<Button
			className={cn(styles.buttonWhite, open && styles.open)}
			color="ghost"
			onClick={onClick}
			data-test={dataTest}
		>
			<span>{children}</span>
			<span className={open ? selectStyles.activeIcon : selectStyles.icon}>
				<Icon name="ChevronDown/Regular" />
			</span>
		</Button>
	);
}

function PopoverWide(props: PopoverProps) {
	const { anchorEl, onClose, children } = props;

	return (
		<UiPopover
			classes={{ paper: cn(selectStyles.popover, styles.popoverWide) }}
			anchorEl={anchorEl}
			open={!!anchorEl}
			onClose={onClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
			data-test="select-popover"
		>
			{children}
		</UiPopover>
	);
}

function BigWhiteSelect<T>(props: SelectProps<T>) {
	return (
		<Select
			{...props}
			render={{
				dropdownButton: DropdownButtonWhite,
				popover: PopoverWide,
				...props.render,
			}}
		/>
	);
}

export default BigWhiteSelect;
